import styled from 'styled-components';
import React from 'react';
import {Icon} from '../../elements/Icon/Icon';

const DropdownArrowSize = `18px`;

export const IconFormSelect = ({icon}) => (
    <DropdownIconContainer>
        <Icon name={icon} />
    </DropdownIconContainer>
);

export const DropdownIconContainer = styled.div`
    width: ${DropdownArrowSize};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: calc((36px / 2) - (${DropdownArrowSize} / 2));
    pointer-events: none;
    z-index: 2;
    color: var(--default-text-color);
`;

// ==== DropdownTreeIcon =====
export const DropdownTreeIcon = () => (
    <DropdownTreeIconContainer>
        <DropdownIconContainer>
            <Icon name="KeyboardArrowDown" />
        </DropdownIconContainer>
        <DropdownIconContainer>
            <Icon name="Search" />
        </DropdownIconContainer>
    </DropdownTreeIconContainer>
);
const DropdownTreeIconContainer = styled.div`
    ${DropdownIconContainer} {
        bottom: 9px;
        top: unset;
        transform: unset;
        &:last-of-type {
            left: 10px;
            right: unset;
            bottom: 10px;
        }
    }
`;
